import './node-os-info-table.style.scss'

class nodeOsInfoTableController {

}

export default nodeOsInfoTableController;



// WEBPACK FOOTER //
// ./ui/src/components/node-os-info-table/node-os-info-table.controller.js